// extracted by mini-css-extract-plugin
export var copyableItem = "_48-0";
export var underlined = "_48-1";